import { render, staticRenderFns } from "./NoPermissionWrapper.vue?vue&type=template&id=2597f068&scoped=true"
import script from "./NoPermissionWrapper.vue?vue&type=script&lang=js"
export * from "./NoPermissionWrapper.vue?vue&type=script&lang=js"
import style0 from "./NoPermissionWrapper.vue?vue&type=style&index=0&id=2597f068&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597f068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2597f068')) {
      api.createRecord('2597f068', component.options)
    } else {
      api.reload('2597f068', component.options)
    }
    module.hot.accept("./NoPermissionWrapper.vue?vue&type=template&id=2597f068&scoped=true", function () {
      api.rerender('2597f068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NoPermissionWrapper.vue"
export default component.exports